import { Avatar, Box, createStyles, makeStyles, Theme, Divider } from "@material-ui/core";
import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Route, Switch } from "react-router-dom";
import Loading from "../../Shared/loading";
import { getUserInfo } from "../redux/actions/guideStreamActions";
import { loadLocalizations } from "../redux/actions/localizationsActions";
import { MentorQueuesData } from "../types";
import ActivePage from "./Active/ActivePage";
import "./App.css";
import CompletedPage from "./Completed/CompletedPage";
import MainTabs from "./MainNavigation/MainTabs";
import QueuePage from "./Queue/QueuePage";
import AssignedPage from "./AssignedToMentor/AssignedPage";
import UpcomingPage from "./Upcoming/UpcomingPage";
import SignOffPage from "./SignOff/SignOffPage";
import useInterval from "../../Shared/useInterval";
import { DateTime } from "luxon";
import { refreshMentorToken, expireMentorToken } from "../../Shared/Redux/Actions/mentorActions";
import ErrorOccurred from "../../Shared/Components/ErrorOccurred";
import SessionExpired from "../../Shared/Components/SessionExpired";
import { ApiErrorType } from "../../Shared/sharedTypes";
import "moment/min/locales";
import moment from "moment";

const mapState = function ({ localizations, sessionToActivate, userInfo, mentorAccess, apiError }: MentorQueuesData) {
    return { localizations, sessionToActivate, userInfo, mentorAccess, apiError };
};

const mapDispatch = {
    loadLocalizations,
    getUserInfo,
    refreshMentorToken,
    expireMentorToken,
};
const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type PropTypes = PropsFromRedux & {};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",

            justifyContent: "space-evenly",
            alignItems: "center",
            "& > *": {
                margin: theme.spacing(1),
            },
        },
    })
);

function App({
    localizations,
    loadLocalizations,
    sessionToActivate,
    getUserInfo,
    userInfo,
    refreshMentorToken,
    mentorAccess,
    expireMentorToken,
    apiError,
}: PropTypes) {
    useEffect(() => {
        if (sessionToActivate) {
            window.location.href = `/mentor.html?q=1&id=${sessionToActivate.sessionId}`;
        }
    }, [sessionToActivate]);
    useEffect(() => {
        getUserInfo(null);
    }, []);

    useEffect(() => {
        if (userInfo && !localizations) {
            loadLocalizations(userInfo.cultureInfo);
        }
        if (userInfo) {
            moment.locale(userInfo.cultureInfo);
        }
    }, [userInfo]);

    //every 2 minutes we see if we are 10 minutes or less away from expiring
    useInterval(function () {
        var expiration = mentorAccess.expiration;
        var now = DateTime.utc();
        if (mentorAccess.token !== "") {
            if (expiration <= now) {
                expireMentorToken();
            } else if (expiration <= now.plus({ minutes: 10 })) {
                refreshMentorToken();
            }
        }
    }, 120000);

    const classes = useStyles();

    if (apiError && apiError.isOccurring) {
        if (apiError.errorType === ApiErrorType.Unauthorized) {
            return <SessionExpired></SessionExpired>;
        } else {
            return <ErrorOccurred></ErrorOccurred>;
        }
    } else if (localizations && userInfo) {
        return (
            <div style={{ position: "relative" }}>
                <Box className="sideBar">
                    <img
                        alt="Guide Stream Logo"
                        src="/images/guidestream360logo.png"
                        style={{ width: "90%", margin: "20px 0px" }}
                    ></img>
                    <Divider />
                    <Box className={classes.root}>
                        <Avatar src={userInfo.photoUrl} style={{ marginRight: 16 }} alt="Self Portrait"></Avatar> {userInfo.firstName}{" "}
                        {userInfo.lastName}
                    </Box>
                    <Divider />
                    <MainTabs localizations={localizations}></MainTabs>
                </Box>
                <Box p={2} className="queueContent">
                    <Switch>
                        <Route path="/assigned" component={AssignedPage} />
                        <Route path="/queue" component={QueuePage} />
                        <Route path="/upcoming" component={UpcomingPage} />
                        <Route path="/active" component={ActivePage} />
                        <Route path="/signoff" component={SignOffPage} />
                        <Route path="/completed" component={CompletedPage} />
                        <Route component={QueuePage} />
                    </Switch>
                </Box>
            </div>
        );
    } else {
        return <Loading message="Initializing" />;
    }
}

export default connector(App);
